<template>
  <b-modal size="lg" centered hide-footer v-model="showModal">
    <div class="d-flex justify-content-center">
      <div class="col-md-12 card">
        <div class="card-body">
          <div class="row">
            <div class="d-flex" style="flex-direction: column">
              <span
                class="mt-3 text-center text-primary"
                style="font-size: 40px !important"
                ><i class="mdi mdi-cloud-upload"></i
              ></span>
              <h5 class="mt-3 mb-3 font-bold">
                Realize a importação da planilha em modelo CSV da instituição financeira
                Sicredi para preencher as informalçoes automaticamente.
              </h5>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <b-form-group label="Instituição Financeira">
                <multiselect
                  v-model="selecaoInstituicaoFinanceira"
                  :options="instituicaoFinanceiraLkp"
                  :disabled="true"
                  label="name"
                  track-by="name"
                />
              </b-form-group>
            </div>
          </div>
          <div class="row mb-2">
            <b-form-group label="Arquivo">
              <input
                ref="fileInput"
                @change="tratarArquivo"
                class="form-control mb-1"
                type="file"
                :state="false"
                :disabled="false"
                accept=".csv,.CSV,.xls,.XLS,.xlsx,.XLSX"
              />
            </b-form-group>
          </div>
          <div class="row">
            <div
              class="col-md-12 col-sm-12 d-flex flex-column flex-md-row justify-content-md-center order-1 order-md-2 mb-2 mb-md-0"
            >
              <b-button
                variant="secondary"
                class="me-md-3 mb-2 mb-md-0"
                @click="fecharModal"
              >
                Voltar
              </b-button>
              <b-button
                variant="success"
                @click="salvarArquivo"
                :disabled="disabledSalvar"
              >
                <i class="mdi mdi-content-save"></i> Salvar
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="disabledSalvar"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      showModal: false,
      disabledSalvar: false,
      instituicaoFinanceiraLkp: [{ name: "SICREDI [748]" }],
      selecaoInstituicaoFinanceira: [{ name: "SICREDI [748]" }],
      arquivo: null,
    };
  },

  methods: {
    abrirModal() {
      this.showModal = true;
    },
    fecharModal() {
      this.showModal = false;
    },
    salvarArquivo() {
      this.disabledSalvar = true;
      console.log(this.arquivo);
      this.disabledSalvar = false;
    },
    async tratarArquivo(event) {
      this.arquivo = event.target.files[0];
    },
  },
};
</script>
